export class ProjectsPermissions {
	add: boolean;
	edit: boolean;
	destroy: boolean;
	archive: boolean;
	see: boolean;
	seeSettings: boolean;
	share: boolean;
	shareInviteLink: boolean;
	shareViewOnlyLink: boolean;
	createLabels: boolean;
	createLabelsFromGroups: boolean;
	updateLabels: boolean;
	deleteLabels: boolean;
	overview: boolean;

	constructor( {
		add = false,
		edit = false,
		destroy = false,
		archive = false,
		see = false,
		seeSettings = false,
		share = false,
		shareInviteLink = false,
		shareViewOnlyLink = false,
		createLabels = false,
		createLabelsFromGroups = false,
		updateLabels = false,
		deleteLabels = false,
		overview = false
	} ) {
		this.add = add;
		this.edit = edit;
		this.destroy = destroy;
		this.archive = archive;
		this.see = see;
		this.seeSettings = seeSettings;
		this.share = share;
		this.shareInviteLink = shareInviteLink;
		this.shareViewOnlyLink = shareViewOnlyLink;
		this.createLabels = createLabels;
		this.createLabelsFromGroups = createLabelsFromGroups;
		this.updateLabels = updateLabels;
		this.deleteLabels = deleteLabels;
		this.overview = overview;
	}
}

export const ownerProjectsPermissions = new ProjectsPermissions( {
	add: true,
	edit: true,
	destroy: true,
	archive: true,
	see: true,
	seeSettings: true,
	share: true,
	shareInviteLink: true,
	shareViewOnlyLink: true,
	createLabels: true,
	createLabelsFromGroups: true,
	updateLabels: true,
	deleteLabels: true,
	overview: true
} );

export const projectManagerProjectsPermissions = new ProjectsPermissions( {
	add: true,
	edit: true,
	destroy: false,
	archive: false,
	see: true,
	seeSettings: true,
	share: true,
	shareInviteLink: true,
	shareViewOnlyLink: true,
	createLabels: true,
	createLabelsFromGroups: true,
	updateLabels: true,
	deleteLabels: true,
	overview: true
} );

export const projectEditorProjectsPermissions = new ProjectsPermissions( {
	add: false,
	edit: false,
	destroy: false,
	archive: false,
	see: true,
	seeSettings: true,
	share: true,
	shareInviteLink: false,
	shareViewOnlyLink: false,
	createLabels: true,
	createLabelsFromGroups: false,
	updateLabels: true,
	deleteLabels: true,
	overview: false
} );

export const projectReviewerProjectsPermissions = new ProjectsPermissions( {
	add: false,
	edit: false,
	destroy: false,
	archive: false,
	see: true,
	seeSettings: false,
	share: false,
	shareInviteLink: false,
	shareViewOnlyLink: false,
	createLabels: false,
	createLabelsFromGroups: false,
	updateLabels: false,
	deleteLabels: false,
	overview: false
} );

export const nullProjectsPermissions = new ProjectsPermissions( {
	add: false,
	edit: false,
	destroy: false,
	archive: false,
	see: false,
	seeSettings: false,
	share: false,
	shareInviteLink: false,
	shareViewOnlyLink: false,
	createLabels: false,
	createLabelsFromGroups: false,
	updateLabels: false,
	deleteLabels: false,
	overview: false
} );
